import { useState, useEffect, React } from 'react'
import './Sec9GrowingConfidence.css'
import Img from '../../Images/Confidence.png'

function Sec9GrowingConfidence() {

  const [daysAgo, setDaysAgo] = useState(0);
  useEffect(() => {
    const calculateDaysAgo = () => {
      const targetDate = new Date("2024-03-27");
      const currentDate = new Date();
      const diffTime = currentDate.getTime() - targetDate.getTime();
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      setDaysAgo(diffDays);
    };

    calculateDaysAgo();

    // Update every 24 hours to keep it accurate
    const interval = setInterval(calculateDaysAgo, 24 * 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="Sec9GrowingConfidence-container container">
      <h3 className="Sec9GrowingConfidence-title">Growing confidence among<br/>MNCs</h3>
      <div className='Sec9GrowingConfidence-sub-container'>
            <div className='Sec9GrowingConfidence-content'>
              <p className="Sec9GrowingConfidence-description text">
              This growing confidence is further bolstered by the concept of ‘security in numbers.’ As more companies witness the success of their peers and service providers within the Indian GCC ecosystem, MNCs are now confident to move from the question of why set up Global Capability Centers to <a href='https://zinnov.com/centers-of-excellence/how-to-set-up-a-captive-center-or-global-capability-center-gcc-blog/' target='_blank'>how to set up a Global Capability Center</a>. it creates a positive reinforcement loop.<br/><br/>This phenomenon is similar to how consumers rely on reviews and ratings on platforms like Amazon; the proven success of existing GCCs in India serves as a strong endorsement, encouraging more companies to invest. The relatively low risk and cost of experimentation in India further sweeten the proposition, making it a compelling choice for multinationals looking to write their own success stories.
              </p>
              <p className="Sec9GrowingConfidence-description text">
              From an under-estimated economy to becoming a hotspot for talent and innovation, India has showcased its prowess. It’s a narrative of consistent growth, strategic evolution, and an ecosystem that is conducive to fostering global capabilities. For global organizations looking to expand their global footprint, India presents a compelling, well-rounded proposition that is hard to overlook.
              </p>
            </div>

            <div className='Sec9GrowingConfidence-right'>
              <div className='Sec9GrowingConfidence-img'>
              <a href="https://zinnov.com/centers-of-excellence/why-set-up-a-global-capability-center-gcc-blog/" target='_blank'><img src={Img} alt="WHY SET UP A GLOBAL CAPABILITY CENTER (GCC)?" className='ImageSec9' /></a>
                <div className='greybox'>
                  <div className='sidebar-blog-category-blk'><span className='category'>GCC</span><span className='dash'> - </span> <span className='read-min'>5 min read</span></div>
                  <h5><a href="https://zinnov.com/centers-of-excellence/why-set-up-a-global-capability-center-gcc-blog/" target='_blank'>WHY SET UP A GLOBAL CAPABILITY CENTER (GCC)?</a></h5>
                  <h6>Discover why it's crucial to set up a Global Capability Center (GCC) and access global talent, drive innovation, and scale your business.</h6>
                  <hr />
                  <div className='content-posted'>
                    <span className='content-posted-person'>
                      <h6><a href='https://zinnov.com/nitika-goel/' target='_blank'>Nitika Goel</a>, Sachit Bhat</h6>
                    </span>
                    <span className='content-posted-time'>
                      <h6>{daysAgo} days ago</h6>
                    </span>
                  </div>
                </div>
              </div>

              <div className='Sec9GrowingConfidence-contactus'>
                <h5>If you want to set up a GCC or an offshore captive center in India, contact us today at <a href="mailto:info@zinnov.com">info@zinnov.com</a>.</h5>
              </div>
            </div>
      </div>
    </div>
  )
}

export default Sec9GrowingConfidence
